/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';
import { InfoBanner, Link } from '@spotahome/ui-library';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { DSIcon } from '@spotahome/ui-library/base';
import ValuePropositionTags from '@spotahome/ui-library/src/tenant/components/ValuePropositionTags/ValuePropositionTags';

import { ListingSectionObservable } from '../ListingSection';
import ListingTitle from '../ListingTitle';

import './CancellationPoliciesVariant.scss';

export const CancellationPoliciesVariant = ({
  securityDepositType,
  isInstantBooking,
  bills,
  isBestChoice,
  plan,
  allowPermanentContract
}) => {
  const seeMoreClickHandler = () => {
    SoyuzAnalytics.sendGA4Event('CancellationPolicies', {
      action: 'SeeMore'
    });
  };

  return (
    <ListingSectionObservable section="cancellationPolicies">
      <ListingTitle role="secondary">
        {trans('cancellation.policies.title')}
      </ListingTitle>

      <div className="cancellation-policies-variant-container">
        <section>
          <div className="cancellation-policies-variant-container__title">
            {trans('cancellation.policies.before.landlord.accepts')}
          </div>
          <p>
            <DSIcon
              name="check_circle_transparent"
              className="cancellation-policies-variant-container__policies__icon"
            />
            {trans('cancellation.policies.nothing.will.be.charged')}
          </p>
        </section>
        <section>
          <div className="cancellation-policies-variant-container__title">
            {trans('cancellation.policies.after.landlord.accepts')}
          </div>

          <ul className="cancellation-policies-variant-container__policies">
            <li
              dangerouslySetInnerHTML={{
                __html: trans('cancellation.policies.60.days.before.bold')
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: trans('cancellation.policies.30.days.before.bold')
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: trans('cancellation.policies.on.move.in.bold')
              }}
            />
          </ul>
        </section>
        <InfoBanner
          icon={<DSIcon name="warning" />}
          theme="suggestion-light"
          closable={false}
          content={
            <span
              dangerouslySetInnerHTML={{
                __html: trans('cancellation.policies.fee.warning.bold')
              }}
            />
          }
          className="cancellation-policies-variant-container__info-banner"
        />
        <ValuePropositionTags
          title={trans(
            'cancellation.policies.value.proposition.remember.title'
          )}
          securityDepositType={securityDepositType}
          isInstantBooking={isInstantBooking}
          bills={bills}
          isBestChoice={isBestChoice}
          plan={plan}
          allowPermanentContract={allowPermanentContract}
        />
        <Link
          onClick={seeMoreClickHandler}
          className="cancellation-policies-variant-container__link"
          href={getPagePath('help-center.cancellation-policies')}
          target="_blank"
          bold
        >
          {trans('cancellation.policies.more.about')}
        </Link>
      </div>
    </ListingSectionObservable>
  );
};

CancellationPoliciesVariant.propTypes = {
  securityDepositType: PropTypes.string.isRequired,
  isInstantBooking: PropTypes.bool.isRequired,
  bills: PropTypes.array.isRequired,
  isBestChoice: PropTypes.bool.isRequired,
  plan: PropTypes.string.isRequired,
  allowPermanentContract: PropTypes.string.isRequired
};

export default CancellationPoliciesVariant;
